<app-contact-header-card-widget
    [form]="this.form"
    [formControl]="this.formControl"
    [detailModel]="model"
    [editEnabled]="props.editEnabled"
    (contactChanged)="onContactChanged($event)"
    (assetChoose)="onAssetChoose($event)"
/>
